import {ConvertorFieldTypeToDataType} from 'src/components/data-types/constants';
import {FieldType} from 'src/openapi/models/FieldType';
import {ItemsType} from 'src/openapi/models/ItemsType';

export const dataTypeString = (fieldType: FieldType, itemsType?: ItemsType) => {
    const currentDataType = fieldType ? ConvertorFieldTypeToDataType[fieldType] : '';
    if ((fieldType === FieldType.ARRAY || fieldType === FieldType.ARRAY_UNIQUE) && itemsType) {
        return `${currentDataType}[${ConvertorFieldTypeToDataType[itemsType]}]`;
    }
    return currentDataType;

};
